/** Playful “noise” items — arcade tone, not CRM error states. */
export const BAD_ITEM_VARIANTS = Object.freeze([
    {
        badItemKey: 'spam',
        labelKey: 'badItems.spam',
        defaultLabel: 'SPAM',
        defaultSubtitle: 'Bandeja a reventar',
        icon: '📧',
    },
    {
        badItemKey: 'urgentMeeting',
        labelKey: 'badItems.urgentMeeting',
        defaultLabel: 'Meeting urgente',
        defaultSubtitle: '¿Tienes 5 minutos?',
        icon: '🔥',
    },
    {
        badItemKey: 'ghostClient',
        labelKey: 'badItems.ghostClient',
        defaultLabel: 'Cliente fantasma',
        defaultSubtitle: 'Lee y no responde',
        icon: '👻',
    },
    {
        badItemKey: 'infiniteExcel',
        labelKey: 'badItems.infiniteExcel',
        defaultLabel: 'Excel infinito',
        defaultSubtitle: 'Solo una columna más',
        icon: '📊',
    },
    {
        badItemKey: 'massCc',
        labelKey: 'badItems.massCc',
        defaultLabel: 'CC masivo',
        defaultSubtitle: '47 personas en copia',
        icon: '📬',
    },
    {
        badItemKey: 'surpriseMeeting',
        labelKey: 'badItems.surpriseMeeting',
        defaultLabel: 'Reunión imprevista',
        defaultSubtitle: '¿De qué hablamos?',
        icon: '📅',
    },
    {
        badItemKey: 'zombieLead',
        labelKey: 'badItems.zombieLead',
        defaultLabel: 'Lead zombie',
        defaultSubtitle: '¿Sigues interesado?',
        icon: '🧟',
    },
    {
        badItemKey: 'coldCoffee',
        labelKey: 'badItems.coldCoffee',
        defaultLabel: 'Café frío',
        defaultSubtitle: 'La máquina otra vez',
        icon: '☕',
    },
    {
        badItemKey: 'duplicate',
        labelKey: 'badItems.duplicate',
        defaultLabel: 'Duplicado',
        defaultSubtitle: 'Ya lo tenemos',
        icon: '👯',
    },
]);

const BAD_ITEM_META_BY_KEY = Object.freeze(
    Object.fromEntries(BAD_ITEM_VARIANTS.map((variant) => [variant.badItemKey, variant])),
);

export function getBadItemMeta(item) {
    if (item?.badItemKey && BAD_ITEM_META_BY_KEY[item.badItemKey]) {
        return BAD_ITEM_META_BY_KEY[item.badItemKey];
    }

    return BAD_ITEM_VARIANTS[0];
}

export function getBadItemLabel(item, t) {
    const meta = getBadItemMeta(item);

    if (typeof t === 'function' && item?.labelKey) {
        return t(item.labelKey, item.label || meta.defaultLabel);
    }

    return item?.label || meta.defaultLabel;
}

export function getBadItemSubtitle(item, t) {
    const meta = getBadItemMeta(item);

    if (typeof t === 'function' && item?.subtitleKey) {
        return t(item.subtitleKey, item.subtitle || meta.defaultSubtitle);
    }

    return item?.subtitle || meta.defaultSubtitle;
}
